import { CardVariant } from '@/constants/scripts'
import i18n from '@/i18n'

export function getHumanizeVariant(variant: CardVariant): string {
  return variant === CardVariant.A
    ? i18n.tc('version.variantNameA')
    : i18n.tc('version.variantNameB')
}
